import { Injectable } from '@angular/core';
import { User } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  private readonly userKey = 'user';
  private readonly tokenKey = 'token';

  constructor() { }

  get storage() {
    return sessionStorage;
  }

  clearStorage() {
    this.storage.removeItem(this.userKey);
    this.storage.removeItem(this.tokenKey);
  }

  saveToken(token: string) {
    this.storage.removeItem(this.tokenKey);
    this.storage.setItem(this.tokenKey, token);
  }

  getToken(): string | null {
    return this.storage.getItem(this.tokenKey);
  }

  saveUser(user: User) {
    this.storage.removeItem(this.userKey);
    this.storage.setItem(this.userKey, JSON.stringify(user));
  }

  getUser(): User | null {
    const key = this.storage.getItem(this.userKey);
    if(key)
    {
      return JSON.parse(key);
    }
    else
    {
      return null;
    }
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    if(token)
    {
      return JSON.parse(token);
    }
    else
    {
      return false;
    }
  }
}
